import { inlineTranslator as t } from "./translator";

export default {
  required: function(item) {
    if (item) return true;
    return t({ en: "Item is required", th: "กรุณากรอกข้อมูล" });
  },
  int_gratter_zero: function(item) {
    if (item > 0) return true;
    return t({ en: "Item is required", th: "กรุณากรอกข้อมูล" });
  },
  min8: function(item) {
    if (item && item.length >= 8) return true;
    return t({
      en: "Min " + (8).toString() + " characters",
      th: "ความยาวขั้นต่ำ " + (8).toString() + " ตัวอักษร",
    });
  },
  min: (num) => (item) => {
    if (item && item.length >= num) return true;
    return t({
      en: "Min " + num.toString() + " characters",
      th: "ความยาวขั้นต่ำ " + num.toString() + " ตัวอักษร",
    });
  },
  range_value_int: (min, max) => (item) => {
    if (item && parseInt(item) >= min && parseInt(item) <= max) return true;
    return t({
      en: "Value must be between " + min.toString() + " - " + max.toString(),
      th: "ต้องมีค่าระหว่าง " + min.toString() + " - " + max.toString(),
    });
  },
  must_be_int: function(item) {
    if (item && Number.isInteger(item)) return true;
    return t({ en: "Must be an integer", th: "ต้องเป็นเลขจำนวนเต็ม" });
  },
  password_match: (string_1) => (item) => {
    if (item && item === string_1) return true;
    return t({ en: "Two password not match", th: "พาสเวิร์ดทั้งสองไม่ตรงกัน" });
  },
  thaiYear: function(item) {
    if (item && item >= 2500 && item <= 2600) return true;
    return t({ en: "Must be in Thai Year", th: "กรุณากรอกเป็นปี พ.ศ." });
  },
  gpa: function(item) {
    if (!/([0-9]{1})+.([0-9]{2})/.test(item)) {
      return t({
        en: "Please fill right format (Ex. 0.00)",
        th: "กรุณากรอกให้ถูกฟอร์แมท (เช่น 0.00)",
      });
    }
    if (item.length != 4) {
      return t({
        en: "Please fill 2 decimal",
        th: "กรุณากรอกทศนิยมให้ครบ 2 หลัก",
      });
    }
    if (item > 4) {
      return t({
        en:
          "GPA must be less than 4.00. / If your GPA score is greater than 4.00, please enter 4.00.",
        th: "GPA ต้องไม่เกิน 4.00 / หาก GPA มากกว่า 4.00 ให้ใส่ค่า 4.00",
      });
    }
    return true;
  },
  credit: function(item) {
    if (!/^\d+$/.test(item)) {
      return t({ en: "Please fill only numbers", th: "กรุณากรอกเฉพาะตัวเลข" });
    }
    if (item.length > 0 && item.length > 2) {
      return t({
        en: "กรุณากรอกตัวเลขไม่เกิน 2 หลัก",
        th: "กรุณากรอกตัวเลขไม่เกิน 2 หลัก",
      });
    }
    return true;
  },
  citizenIdThai: function(item) {
    if (!/^\d+$/.test(item)) {
      return t({ en: "Please fill only numbers", th: "กรุณากรอกเฉพาะตัวเลข" });
    }
    if (item.length > 0 && item.length !== 13) {
      return t({
        en: "Please Complete Number 13 Digits",
        th: "กรุณากรอกตัวเลข 13 ตัว",
      });
    } else {
      var sum = 0;
      var i = 0;
      for (i = 0; i < 12; i++) {
        sum += parseInt(item.charAt(i)) * (13 - i);
      }

      if ((11 - (sum % 11)) % 10 !== parseInt(item.charAt(12))) {
        return t({
          en: "Thai citizen ID is invalid",
          th: "กรุณากรอกเลขประจำตัวประชาชนให้ถูกต้อง",
        });
      }
    }
    return true;
  },
  passport: function(item) {
    if (!/^([a-z0-9])+$/i.test(item)) {
      return t({
        en: "Enter only numbers and letters in English.",
        th: "กรอกได้เฉพาะตัวเลขและตัวอักษรภาษาอังกฤษเท่านั้น",
      });
    }

    return true;
  },
  mobile: function(item) {
    if (!/^\d+$/.test(item)) {
      return t({ en: "Please fill only numbers", th: "กรุณากรอกเฉพาะตัวเลข" });
    }
    if (item.length > 0 && item[0] !== "0") {
      return t({ en: "The 1st number is 0", th: "ต้องขึ้นต้นด้วย 0" });
    }
    if (item.length > 0 && item.length !== 10) {
      return t({
        en: "Please Complete Number 10 Digits",
        th: "กรุณากรอกเลขให้ครบ 10 หลัก",
      });
    }
    return true;
  },
  email: function(item) {
    if (!/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(item)) {
      return t({ en: "Fill false format", th: "กรุณากรอกให้ตรงฟอร์แมท" });
    }
    return true;
  },
  minChar: (num) => (item) => {
    if (!item || item.length < num) {
      return t({
        en: "Minimum " + num.toString() + " characters",
        th: "ความยาวขั้นต่ำ " + num.toString() + " ตัวอักษร",
      });
    }
    return true;
  },
  section: function(item) {
    if (!/^\d+$/.test(item)) {
      return t({ en: "Please fill only numbers", th: "กรุณากรอกเฉพาะตัวเลข" });
    }
    if (item[0] == 0) {
      return t({ en: "The 1st digit can not be 0", th: "ห้ามขึ้นต้นด้วย 0" });
    }
    if (item.length > 4) {
      return t({ en: "More than 4 digits", th: "เกิน 4 หลัก" });
    }
    return true;
  },
  amount: function(item) {
    if (!/^\d+$/.test(item)) {
      return t({ en: "Please fill only numbers", th: "กรุณากรอกเฉพาะตัวเลข" });
    }
  },
  student_id: function(item) {
    if (item && item.length == 8) return true;
    return t({
      en: "Student ID must be equal 8 characters",
      th: "รหัสนักศึกษาต้องมี 8 ตัวอักษร",
    });
  },
};
